import { render, staticRenderFns } from "./ListDHRCustomValues.vue?vue&type=template&id=0cd74af8&scoped=true&"
import script from "./ListDHRCustomValues.vue?vue&type=script&lang=js&"
export * from "./ListDHRCustomValues.vue?vue&type=script&lang=js&"
import style0 from "./ListDHRCustomValues.vue?vue&type=style&index=0&id=0cd74af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd74af8",
  null
  
)

export default component.exports